<div class="modal-header p-dialog-header flex-between">
    <div class="d-flex align-items-center">
        <img src="assets\svg\dialog\Confirmation-w.svg" />
        <span class="text-16 font-medium ms-3" id="title_SetSiteFormat">{{translate?.site.label.singular}}&nbsp;{{translate?.setup.modules.configuration.fields.format.singular}}</span>
    </div>
    <i class="fa-regular fa-xmark" [pTooltip]="translate?.general.buttons.close.singular" tooltipPosition="left" (click)="modalRef.hide()" id="btn_SetSiteClose"></i>
</div>
<div class="modal-body tix height-80">
    <div class="m-0 pb-3 px-2">
        <span class="text-12 d-block font-semiBold" id="label_SetSiteFormatNo" >{{translate?.setup.modules.configuration.messages.whatIs}}&nbsp;{{translate?.site.label.singular}}&nbsp;{{translate?.setup.modules.configuration.fields.format.singular}}&quest;</span>
        <span class="text-12" id="value_SetiteFormatNoDesc" >{{translate?.site.label.singular}}&nbsp;{{translate?.setup.modules.configuration.fields.format.singular}}&nbsp;{{translate?.setup.modules.configuration.messages.allowsCustomize}}</span>
    </div>
    <div>
        <p-table [value]="tix" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
                <tr class="">
                    <th class="col-2" id="label_SetSiteVar">{{translate?.setup.modules.configuration.sections.sec2.singular}}</th>
                    <th class="col-2" id="label_SetSiteNec">{{translate?.setup.modules.configuration.sections.sec3.singular}}</th>
                    <th class="col-2" id="label_SetSiteDesc">{{translate?.setup.modules.configuration.sections.sec4.singular}}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-tix>
                <tr class="text-12 font-medium">
                    <td class="col-2" id="value_SetSiteVar">{{ tix.variable }}</td>
                    <td class="col-2 text-left" id="value_SetSiteNec">{{ tix.necessity }}</td>
                    <td class="col-2 text-left" id="value_SetSiteDesc">{{ tix.desc }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div class="pt-2">
        <div class="m-1">
            <span class="text-12 font-medium" id="label_SetSiteFormatEg">{{translate?.setup.modules.configuration.messages.hereExamples}}</span>
        </div>
        <p-table [value]="tix2" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
                <tr class="">
                    <th class="col-2" id="label_SetSiteFormat">{{translate?.site.label.singular}}&nbsp;{{translate?.setup.modules.configuration.fields.format.singular}}</th>
                    <th class="col-2" id="label_SetSiteSeqNo">{{translate?.setup.modules.configuration.sections.sec6.singular}}</th>
                    <th class="col-2" id="label_SetSiteFormatNo">{{translate?.setup.modules.configuration.sections.sec7.singular}}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-tix2>
                <tr class="text-12 font-medium">
                    <td id="value_SetSiteFormat">{{ tix2.format }}</td>
                    <td class="col-2 text-left">
                        <tr id="value_SetSiteSeqNo1">
                            {{ tix2.seq1 }}
                        </tr>
                        <tr id="value_SetSiteSeqNo2">
                            {{ tix2.seq2 }}
                        </tr>
                    </td>
                    <td class="col-2 text-left">
                        <tr id="value_SetSiteFormatNo1">
                            {{ tix2.number1 }}
                        </tr>
                        <tr id="value_SetSiteFormatNo2">
                            {{ tix2.number2 }}
                        </tr>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
